<script>
import axios from "axios";

import i18n from "../i18n";

//import simplebar from "simplebar-vue";

/**
 * Nav-bar Component
 */
export default {
  data() {
    return {
      languages: [
        {
          flag: require("@/assets/images/flags/us.jpg"),
          language: "en",
          title: "English",
        },
        {
          flag: require("@/assets/images/flags/french.jpg"),
          language: "fr",
          title: "French",
        },
        {
          flag: require("@/assets/images/flags/spain.jpg"),
          language: "es",
          title: "Spanish",
        },
        {
          flag: require("@/assets/images/flags/chaina.png"),
          language: "zh",
          title: "Chinese",
        },
        {
          flag: require("@/assets/images/flags/arabic.png"),
          language: "ar",
          title: "Arabic",
        },
      ],
      lan: i18n.locale,
      text: null,
      flag: null,
      value: null,

      token: "",
      user: {},
    };
  },
  components: { 
    //simplebar 
  },
  mounted() {
    this.value = this.languages.find((x) => x.language === i18n.locale);
    this.text = this.value.title;
    this.flag = this.value.flag;

    this.getToken();
  },
  methods: {
    toggleMenu() {
      this.$parent.toggleMenu();
    },
    toggleRightSidebar() {
      this.$parent.toggleRightSidebar();
    },
    initFullScreen() {
      document.body.classList.toggle("fullscreen-enable");
      if (
        !document.fullscreenElement &&
        /* alternative standard method */ !document.mozFullScreenElement &&
        !document.webkitFullscreenElement
      ) {
        // current working methods
        if (document.documentElement.requestFullscreen) {
          document.documentElement.requestFullscreen();
        } else if (document.documentElement.mozRequestFullScreen) {
          document.documentElement.mozRequestFullScreen();
        } else if (document.documentElement.webkitRequestFullscreen) {
          document.documentElement.webkitRequestFullscreen(
            Element.ALLOW_KEYBOARD_INPUT
          );
        }
      } else {
        if (document.cancelFullScreen) {
          document.cancelFullScreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen();
        }
      }
    },
    setLanguage(locale, country, flag) {
      this.lan = locale;
      this.text = country;
      this.flag = flag;
      i18n.locale = locale;
    },

    getToken() {
      if (localStorage.getItem('medicino_admin')) {
        var medicino_admin =  JSON.parse(localStorage.getItem('medicino_admin'));
        if(medicino_admin.token) {

          this.token = medicino_admin.token;
          this.user = medicino_admin;
          
        } else {
          this.$swal("", "Failed to fetch token, please login again", "error");
          this.$router.push({ name: "login" });
        }
               
      } else {
        this.$swal("", "Session expired, please login again", "error");
        this.$router.push({ name: "login" });
      }
    }, 

    logout() {

      let url = "api/logout";         
      this.getToken();
      this.loading = true;
      this.$axios
      .get(url, { headers: { Authorization: "Bearer " + this.token } })
      .then((res) => {
        var responseData = res.data.data;
        console.log(responseData);
        
        if(localStorage.getItem('medicino_admin')) {
          localStorage.removeItem("medicino_admin");    
        }         
        this.$swal("", "You have been successfully logged out", "success");
        this.$router.push({ name: "login" });
                        
      })
      .catch((error) => {
        if (error.response) {
          if (error.response.data.message) {
            if(typeof error.response.data.message === 'object') {
              console.log(error.response.status);
            } else {
              this.$swal("", error.response.data.message, "error");
            }                        
                        
          } else {
            this.$swal("", "Something went wrong", "error");
          }
        } else {
          this.$swal("", "Something went wrong", "error");
        }
      })
      .finally(() => (this.loading = false));

      
    },

    logoutUser() {
      // eslint-disable-next-line no-unused-vars
      axios.get("http://127.0.0.1:8000/api/logout").then((res) => {
        this.$router.push({
          name: "default",
        });
      });
    },
  },
};
</script>

<style type="text/css">
  .logo h1 {
    text-transform: uppercase;
    font-weight: 600;
    font-size: 20px;
    line-height: 24px;
    margin-bottom: 0;
    margin-top: 20px;
    color: #eee;
  }
</style>

<template>
  <header id="page-topbar">
    <div class="navbar-header">
      <div class="d-flex">
        <!-- LOGO -->
        <div class="navbar-brand-box">
          
          <!-- <router-link tag="a" to="/" class="logo logo-dark">
            <span class="logo-sm">
              <img src="@/assets/images/logo.png" alt height="22" />
            </span>
            <span class="logo-lg">
              <img src="@/assets/images/logo-dark.png" alt height="17" />
            </span>
          </router-link>-->

          <router-link tag="a" to="/" class="logo logo-light">
            <span class="logo-sm">
              <img src="@/assets/images/logo.png" alt height="40" />
            </span>
            <span class="logo-lg">
              <img src="@/assets/images/logo-light.png" alt height="50" />
            </span>
          </router-link> 

          <!-- <router-link tag="a" to="/" class="logo">
            <h1>Vaahan Connect</h1>
          </router-link> -->
        </div>

        <button
          id="vertical-menu-btn"
          type="button"
          class="btn btn-sm px-3 font-size-16 header-item"
          @click="toggleMenu"
        >
          <i class="fa fa-fw fa-bars"></i>
        </button>
        
      </div>

      <div class="d-flex">
        

        <div class="dropdown d-none d-lg-inline-block ms-1">
          <button
            type="button"
            class="btn header-item noti-icon"
            @click="initFullScreen"
          >
            <i class="bx bx-fullscreen"></i>
          </button>
        </div>

       

        <b-dropdown right variant="black" toggle-class="header-item" menu-class="dropdown-menu-end">
          <template v-slot:button-content>
            <!-- <img
              class="rounded-circle header-profile-user"
              src="@/assets/images/users/avatar-7.jpg"
              alt="Header Avatar"
            />
            <span class="d-none d-xl-inline-block ms-1">{{
              $t("navbar.dropdown.admin.text")
            }}</span> -->

            <img v-if="user && user.image" :src="$image_url + user.image" class="avatar-sm rounded-circle" alt="" />
            <img v-else src="@/assets/images/no-user.jpg" class="avatar-sm rounded-circle" alt="" />

            <span  class="d-none d-xl-inline-block ms-1">{{user.name}}</span>
            <i class="mdi mdi-chevron-down d-none d-xl-inline-block"></i>
          </template>
          <!-- item-->
          
          <b-dropdown-item class="d-block" href="/settings">
            <!-- <span class="badge bg-success float-end">11</span> -->
            <i class="bx bx-wrench font-size-16 align-middle me-1"></i>
            {{ $t("navbar.dropdown.admin.list.settings") }}
          </b-dropdown-item>
          <!-- <b-dropdown-item href="javascript: void(0);">
            <i class="bx bx-lock-open font-size-16 align-middle me-1"></i>
            {{ $t("navbar.dropdown.admin.list.lockscreen") }}
          </b-dropdown-item> -->
          <b-dropdown-divider></b-dropdown-divider>
          <a href="#" class="dropdown-item text-danger" @click.prevent="logout()">
            <i
              class="bx bx-power-off font-size-16 align-middle me-1 text-danger"
            ></i>
            {{ $t("navbar.dropdown.admin.list.logout") }}
          </a>
        </b-dropdown>

       
      </div>
    </div>
  </header>
</template>
